import { AppShell, Center, useUpdateBodyBackground } from '@tf/ui';
import type React from 'react';
import { Outlet } from 'react-router-dom';

import { Affix } from './Affix';
import { Footer } from './Footer';
import { MenuProvider } from './MenuProvider';

export const CaseLayout: React.FC = () => {
	useUpdateBodyBackground('#F9FAFB');

	return (
		<MenuProvider>
			<AppShell layout="alt">
				<AppShell.Main mih="calc(100dvh - 70px)">
					<Center p="24px">
						<Outlet />
					</Center>
				</AppShell.Main>
				<Affix />
				<Footer withBorder />
			</AppShell>
		</MenuProvider>
	);
};
